export enum AssignIgnoreScoreOptionType {
  Hide = "Hide",
  ShowDefaultOn = "ShowDefaultOn",
  ShowDefaultOff = "ShowDefaultOff"
}
